<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to My Attendance Menu" @click="$router.push('/myattendance')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" pageId="attendance-corrections" color="white"></help-link>
                    <v-menu left v-model="menu_status" offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on">
                                &nbsp;&nbsp;CY {{selectedFiscalYear}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense v-for="(item,index) in fiscal_years" :key="index" :title="`Caledar Year ${item.fiscalYear}`">
                            <v-list-tile @click="setSelectedYear(item.fiscalYear)">
                                <v-list-tile-title small>CY {{item.fiscalYear}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-card>
            <!-- <v-alert :value="true" color="info" icon="info" outline dismissible style="margin-top:5px;">
                To file an attendance correction, go to <b @click="$router.push('/myattendance/calendar')" style="text-decoration:underline; cursor:pointer;">My Calendar</b> to view your monthly attendance. Select the desired date by clicking the menu button, then click the "View Attendance Details" icon.
            </v-alert> -->
            <v-card class="elavation-1" style="margin-top:5px;">
                <v-toolbar flat height="45px">
                    <div class="wp-30 mb-10">
                        <v-text-field v-model="search" append-icon="search" :label="searchLabel" single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                    <span>
                        <v-switch
                            v-model="viewAll"
                            label="View all"
                            color="primary"
                            hide-details
                        ></v-switch> 
                    </span>
                </v-toolbar>

                <!-- by cutoff -->
                <v-data-table
                    :headers="headers"
                    :items="summary_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync1"
                    v-show="!viewAll"
                >
                    <template v-slot:items="props">
                        <tr @click="viewCutoffDetails(props.item)" style="cursor:pointer;" title="Click to view timesheet for this period">
                            <td>
                                <span v-if="props.item.cutOffPeriodDesc=='Current'" class="font-weight-bold">{{props.item.cutOffPeriodDesc}}</span>
                                <span v-else>{{props.item.cutOffPeriodDesc}}</span>
                            </td>
                            <td>{{ props.item.cutOffStart | moment("YYYY-MM-DD") }}</td>
                            <td>{{ props.item.cutOffEnd | moment("YYYY-MM-DD") }}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.cutOffStatus)">{{commonfn.getStatusDescription(props.item.cutOffStatus)}}</b>
                            </td>
                            <td>{{ props.item.attendanceCorrectionsCount }}</td>
                        </tr>
                    </template>
                </v-data-table> 

                <!-- by calendar year -->
                <v-data-table
                    :headers="headers_all"
                    :items="att_corrections_all_filtered"
                    :loading="loading"  
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync2"
                    v-show="viewAll"
                >
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" style="cursor:pointer;">
                            <td>
                                {{ props.item.transDate | moment('YYYY-MM-DD (ddd)') }}
                            </td>
                            <td>{{ props.item.clockIn | moment('hh:mm a') }}</td>
                            <td>{{ props.item.clockOut | moment('hh:mm a') }}</td>
                            <td>{{ props.item.totalHours }}</td>
                            <td>{{ props.item.chargeableHours }}</td>                                                
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout> 
</template>
<script>

import attCorrectionsApi from '@/api/attendancecorrection'
import commonfn from '@/common/functions'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'AttendanceCorrections',
    metaInfo: {
        title: 'Attendance Corrections',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'My Timesheet' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    data () {
        const routeName1 = `${this.$route.name}-table1`
        const routeName2 = `${this.$route.name}-table2`
        const savedSort1 = userPrefs.getSort(routeName1)
        const savedSort2 = userPrefs.getSort(routeName2)

        return {
            commonfn,
            rowsPerPageItems,
            paginationSync1: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName1),
                sortBy: savedSort1.sortBy,
                descending: savedSort1.descending,
            },
            paginationSync2: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName2),
                sortBy: savedSort2.sortBy,
                descending: savedSort2.descending,
            },
            viewAll: userPrefs.getViewAllSwitch(this.$route.name),
            selectedFiscalYear: userPrefs.getCalendarYear(this.$route.name),
            error: false,
            errorMessage: '',
            loading: false,
            headers: [
                {text: 'Period',align: 'left',value: 'cutOffPeriodDesc', width: '10%', sortable:true},
                {text: 'Cutoff Start Date',align: 'left',value: 'cutOffStart', width: '10%', sortable:true},
                {text: 'Cutoff End Date',align: 'left',value: 'cutOffEnd', width: '10%', sortable:true},
                {text: 'Cutoff Status',align: 'left',value: 'cutOffStatus',  width: '10%', sortable:true},
                {text: 'Attendance Corrections Items',align: 'left',value: 'attendanceCorrectionsCount',  width: '10%', sortable:true},
            ],
            headers_all: [
                {text: 'Date', align: 'left',value: 'transDate', width:'15%', sortable:true},
                {text: 'Clock-In', align: 'left',value: 'clockIn', width:'10%' ,sortable:true},
                {text: 'Clock-Out', align: 'left',value: 'clockOut', width:'10%', sortable:true},
                {text: 'Total Hours', align: 'left',value: 'totalHours', width:'10%', sortable:true},
                {text: 'Chargeable Hours', align: 'left',value: 'chargeableHours', width:'10%', sortable:true}, 
                {text: 'Status',align: 'left', value:'status', width:'15%', sortable:true},
            ],
            att_corrections_summary: [],
            att_corrections_all: [],
            search: null,
            menu_status: false,
        }
    },
    methods: {
        setSelectedYear(fiscalYear) {
            this.selectedFiscalYear = fiscalYear
            userPrefs.updateCalendarYear(this.$route.name, fiscalYear)
            this.initialize(false)
        },
        viewCutoffDetails(data) {
            this.$router.push(`corrections/${data.cutOffId}`)
        },  
        viewDetails(data) {
            this.$router.push(`corrections/details/${data.attendanceCorrectionsId}`)
        }, 
        async getAttCorrectionsSummary(show_loading) {
            try {
                this.loading = show_loading
                const response = await attCorrectionsApi.getSummary()     
                if (response && response.status == 200) {
                    this.att_corrections_summary = response.data.summaryItems
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }, 
        async getAllAttCorrections(show_loading) {
            try {
                 this.loading = show_loading
                const response = await attCorrectionsApi.getByFYByUser(this.selectedFiscalYear)     
                if (response && response.status == 200) {
                    this.att_corrections_all = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }, 
        initialize(show_loading) {
            if (this.viewAll) 
                this.getAllAttCorrections(show_loading)
            else
                this.getAttCorrectionsSummary(show_loading)
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: 'My Attendance Corrections',
            headerPageTitle: ''
        })

        this.initialize(true)
    },
    watch: {
        'paginationSync1.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-table1`, newVal);
        },
        'paginationSync2.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-table2`, newVal);
        },
        'paginationSync1.sortBy'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-table1`, newVal, this.paginationSync1.descending)
        },
        'paginationSync2.sortBy'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-table2`, newVal, this.paginationSync2.descending)
        },
        'paginationSync1.descending'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-table1`, this.paginationSync1.sortBy, newVal)
        },
        'paginationSync2.descending'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-table2`, this.paginationSync2.sortBy, newVal)
        },
        viewAll(newVal) {
            userPrefs.updateViewAllSwitch(this.$route.name, newVal)
            this.initialize(false)
        }
    },
    computed: {
        summary_filtered() {
            var temp = this.att_corrections_summary.filter(item => {
                return (item.fiscalYear==this.selectedFiscalYear && !item.cutOffPeriodDesc.includes('Upcoming'))
            })
            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.cutOffStart.includes(this.search))
                })
            }
            return temp //.reverse()
        },
        att_corrections_all_filtered() {
            var temp = this.att_corrections_all

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.transDate.includes(this.search))
                })
            }
            return temp
        },
        searchLabel() {
            if (this.viewAll) return 'Search date'
            return 'Search cutoff date'
        },
        fiscal_years() {
            if (this.$store.state.fiscalPeriods) {
                return this.$store.state.fiscalPeriods
            }
            return [{fiscalYear: new Date().getFullYear()}]
        }
    }
}
</script>